<template>
  <div class="container mt-5 mb-5">
    <md-card class="text-center">
      <md-card-header>
        <div class="md-title">Alta</div>
        <!-- <div class="md-subhead">Ingresa los campos solicitados.</div> -->
      </md-card-header>

      <md-card-content>
        <div class="row">
          <div class="col-md-4">
            <md-field>
              <label>Póliza</label>
              <md-input value="60000893" disabled></md-input>
            </md-field>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-md-4">
            <md-field>
              <label>Nombre</label>
              <md-input v-model="nombreAlta" maxlength="20"></md-input>
            </md-field>
          </div>
          <div class="col-md-4">
            <md-field>
              <label>Apellido Paterno</label>
              <md-input v-model="paternoAlta"></md-input>
            </md-field>
          </div>
          <div class="col-md-4">
            <md-field>
              <label>Apellido Materno</label>
              <md-input v-model="maternoAlta"></md-input>
            </md-field>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-md-4">
            <md-field>
              <md-select
                name="sexo"
                id="sexo"
                placeholder="Sexo"
                v-model="sexoAlta"
              >
                <md-option
                  v-for="option in catalogoSexo"
                  :key="option.Descripcion"
                  :value="option.Val_campo"
                >
                  {{ option.Descripcion }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="col-md-4">
            <md-field>
              <md-select
                name="civil"
                id="Civil"
                placeholder="Estado Civil"
                v-model="civilAlta"
              >
                <md-option
                  v-for="option in catalogoEdoCivil"
                  :key="option.Descripcion"
                  :value="option.Descripcion"
                >
                  {{ option.Descripcion }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="col-md-4">
            <md-field>
              <label class="md-required">Fecha de nacimiento</label>
              <md-input type="date" v-model="nacimientoAlta"></md-input>
            </md-field>
          </div>
          <div class="col-md-4">
            <md-field>
              <label>Estatus</label>
              <md-input disabled value="Pendiente"></md-input>
            </md-field>
          </div>
        </div>
        <!-- <div class="row d-flex justify-content-center">
                      
                    </div> -->
        <!-- <div class="row">
                            <div class="col-md-6 text-center">
                                <div class="row ">
                                    <p style="color: #586875;">Clave CTP seleccionado: <b>{{ showCTP }}</b></p>            
                                </div>
                                <div class="row">
                                    <div>
                                        <md-dialog :md-active.sync="showDialogAltaCTP">
                                            <div class="row pr-5 pl-5 pt-5 text-center">
                                                <div class="col-5">
                                                    <md-field>
                                                        <label>CTP Clave</label>
                                                        <md-input type="number" v-model="ctpClave"></md-input>
                                                    </md-field> 
                                                </div>
                                                <div class="col-5">
                                                    <md-field>
                                                        <label>CTP Descripción</label>
                                                        <md-input v-model="ctpDesc"></md-input>
                                                    </md-field> 
                                                </div>
                                                <div class="col">
                                                    <md-button class="md-primary" style="background: #f26e50; color: white;" 
                                                        @click="CTP"> 
                                                        <i class="fas fa-search mr-2"></i>
                                                        Buscar
                                                    </md-button>
                                                </div>
                                            </div>
                                            <md-dialog-content>
                                                <md-tabs md-dynamic-height>
                                                    <md-tab md-label="CTP">
                                                        <div>
                                                            <md-table v-model="catalogoCTP" md-card @md-selected="onSelectAltaCTP" md-fixed-header>
                                                            <md-table-row slot="md-table-row" slot-scope="{ item }" :class="getClassCTP(item)" md-selectable="single">
                                                                <md-table-cell md-label="Clave" md-sort-by="Clave" md-numeric>{{ item.CVEL_CPT }}</md-table-cell>
                                                                <md-table-cell md-label="Descripcion" md-sort-by="NombreComercial">{{ item.DESC_CPT }}</md-table-cell>
                                                            </md-table-row>
                                                            </md-table>
                                                        </div>
                                                    </md-tab>
                                                </md-tabs>
                                                <md-dialog-actions>
                                                </md-dialog-actions>
                                            </md-dialog-content>
                                            
                                        </md-dialog>

                                        <md-button class="md-primary md-raised col-6" @click="showDialogAltaCTP = true"
                                        style="background-color:#9cc4e4; color: #fff;">Buscar CTP</md-button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 text-center">
                                <div class="row">
                                    <p style="color: #586875;">Clave ICD seleccionado: <b>{{ showICD }}</b></p>            
                                </div>
                                <div class="row">
                                    <div>
                                        <md-dialog :md-active.sync="showDialogAltaICD">
                                            <div class="row pr-5 pl-5 pt-5 text-center">
                                                <div class="col-5">
                                                    <md-field>
                                                        <label>ICD Clave</label>
                                                        <md-input type="number" v-model="icdClave"></md-input>
                                                    </md-field> 
                                                </div>
                                                <div class="col-5">
                                                    <md-field>
                                                        <label>ICD Descripción</label>
                                                        <md-input v-model="icdDesc"></md-input>
                                                    </md-field> 
                                                </div>
                                                <div class="col">
                                                    <md-button class="md-primary" style="background: #f26e50; color: white;" 
                                                        @click="ICD"> 
                                                        <i class="fas fa-search mr-2"></i>
                                                        Buscar
                                                    </md-button>
                                                </div>
                                            </div>
                                            <md-dialog-content>
                                                <md-tabs md-dynamic-height>
                                                    <md-tab md-label="ICD">
                                                        <div>
                                                            <md-table v-model="catalogoICD" md-card @md-selected="onSelectAltaICD" md-fixed-header>
                                                            <md-table-row slot="md-table-row" slot-scope="{ item }" :class="getClassICD(item)" md-selectable="single">
                                                                <md-table-cell md-label="Clave" md-sort-by="Clave" md-numeric>{{ item.CVEL_ICD }}</md-table-cell>
                                                                <md-table-cell md-label="Descripcion" md-sort-by="NombreComercial">{{ item.DESC_ENFERMEDAD }}</md-table-cell>
                                                            </md-table-row>
                                                            </md-table>
                                                        </div>
                                                    </md-tab>
                                                </md-tabs>
                                                <md-dialog-actions>
                                                </md-dialog-actions>
                                            </md-dialog-content>
                                            
                                        </md-dialog>

                                        <md-button class="md-primary md-raised col-6" @click="showDialogAltaICD = true"
                                        style="background-color:#9cc4e4; color: #fff;">Buscar ICD</md-button>
                                    </div>
                                </div>
                            </div>
                    </div> -->
      </md-card-content>
    </md-card>
    <Tabs
      :catalogoLesion.sync="catalogoLesion"
      :catalogoEspacio.sync="catalogoEspacio"
      :catalogoCuerpo.sync="catalogoCuerpo"
      :catalogoAccidente.sync="catalogoAccidente"
      :catalogoUbicacion.sync="catalogoUbicacion"
      :catalogoHospitales.sync="catalogoHospitales"
      :catalogoEscuelas.sync="catalogoEscuelas"
      :catalogoICD.sync="catalogoICD"
      :catalogoCTP.sync="catalogoCTP"
      :icdClave="icdClave"
      :icdDesc="icdDesc"
      :ctpClave="ctpClave"
      :ctpDesc="ctpDesc"
      :methodCTP="CTP"
      :methodICD="ICD"
      @dataTabs="PdfAvisoAccidente"
      @update-icd-clave="updateIcdClave"
      @update-icd-desc="updateIcdDesc"
      :textoBoton="'Guardar alta'"
    />
    <Loading :isLoading="isLoading" />
    <SuccessModal
      :showDialog="showSuccess"
      :mensaje="mensajeSuccess"
      :reloadPage="reloadPage"
    />
    <ErrorModal :showDialog="showError" :mensaje="mensajeError" />
    <AlertModal :showDialog="showAlert" :mensaje="mensajeAlert" />
  </div>
</template>
  
  <script>
import Tabs from "./tabs.vue";
import Loading from "./Tools/loading.vue";
import SuccessModal from "./Modals/successModal.vue";
import ErrorModal from "./Modals/errorModal.vue";
import AlertModal from "./Modals/alertModal.vue";
export default {
  components: {
    Tabs,
    Loading,
    SuccessModal,
    ErrorModal,
    AlertModal,
  },
  data() {
    return {
      userId: localStorage.getItem("userId"),
      isLoading: false,
      reloadPage: false,
      showDialogAltaCTP: false,
      showDialogAltaICD: false,
      selectedAltaCTP: {},
      selectedAltaICD: {},
      catalogoICD: [],
      catalogoCTP: [],
      showCTP: "",
      ctpClave: "",
      ctpDesc: "",
      showICD: "",
      icdClave: "",
      icdDesc: "",
      nombreAlta: "",
      paternoAlta: "",
      maternoAlta: "",
      nacimientoAlta: "",
      sexoAlta: "",
      civilAlta: "",
      fechaReclamacion: "",
      fechaGasto: "",
      errorsAlta: {
        nombreAlta: false,
        paternoAlta: false,
        maternoAlta: false,
        nacimientoAlta: false,
        sexoAlta: false,
        civilAlta: false,
      },
      //Catalogos
      catalogoLesion: [],
      catalogoEspacio: [],
      catalogoCuerpo: [],
      catalogoAccidente: [],
      catalogoUbicacion: [],
      catalogoHospitales: [],
      catalogoEscuelas: [],
      catalogoEdoCivil: [],
      catalogoSexo: [],
      catalogoICD: [],
      catalogoCTP: [],
      //alerts
      showSuccess: false,
      showError: false,
      showAlert: false,
      mensajeAlert: "",
      mensajeError: "",
      mensajeSuccess: "",

      //GrabarAltaRegistroSiniestro
      pIdFolio: "",

      //PendienetFolioIseo
      base64Folio: "",
      folioISEP: "",
    };
  },
  methods: {
    updateIcdClave(value) {
      this.icdClave = value;
    },
    updateIcdDesc(value) {
      this.icdDesc = value;
    },

    validateFields(data) {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      const camposRequeridos = {
        Nombre: this.nombreAlta,
        "Apellido Paterno": this.paternoAlta,
        "Apellido Materno": this.maternoAlta,
        Sexo: this.sexoAlta,
        "Estado Civil": this.civilAlta,
        "Fecha de registro": data.dateRegistro,
        "Fecha de 1er. gasto": data.primerGasto,
        "Fecha de 1er. reclamación": data.primerReclamacion,
        "Hora de Registro": data.horaRegistro,
        "Descripcion de registro": data.descripcionRegistro,
        "Seguro de la Escuela": data.seguro,
        "Clave de la Escuela": data.clave,
        "Nombre de la Escuela": data.nombreEscuela,
        "Nivel de la Escuela": data.nivel,
        "Municipio de la Escuela": data.municipio,
        Ubicación: data.ubicacion,
        Espacio: data.espacio,
        Accidente: data.accidente,
        Lesion: data.lesion,
        Cuerpo: data.cuerpo,
        "Nombre del acompañante": data.nombre,
        "Apellido paterno del acompañante": data.apellidoPaterno,
        "Apellido materno del acompañante": data.apellidoMaterno,
        "Parentesco del acompañante": data.parentesco,
        "Teléfono del acompañante": data.telefono,
        "Correo del acompañante": data.correo,
        Clinica: data.selectedHospital,
        ICD: data.ICD,
        CTP: data.CTP,
        Observaciones: data.observaciones,
        Autorizado: data.autorizado,
        "Fecha de Consulta": data.dateConsulta,
      };

      for (const [campo, valor] of Object.entries(camposRequeridos)) {
        if (
          !valor ||
          (typeof valor === "object" && Object.keys(valor).length === 0)
        ) {
          this.showError = true;
          this.mensajeError = `El campo ${campo} es requerido.`;
          setTimeout(() => {
            this.showError = false;
          }, 3000);
          return false;
        }
      }

      if (data.telefono.length > 10 || data.telefono.length < 10) {
        this.showError = true;
        this.mensajeError = `El campo Teléfono del acompañante es inválido.`;
        return false;
      }

      if (!emailPattern.test(data.correo)) {
        this.mensajeError =
          "El Correo del acompañante no tiene un formato válido";
        this.showError = true;
        return false;
      }

      return true; // Si todas las validaciones pasan
    },

    async PdfAvisoAccidente(data) {
      this.dataRecibida = data;
      this.$set(data, "selectedPerson", this.selected);

      if (!this.validateFields(data)) {
        return; // Si las validaciones fallan, detenemos el flujo
      }

      const payload = {
        metodo: "GETPDFISEP",
        data: {
          NombreAsegurado:
            `${this.nombreAlta} ${this.paternoAlta} ${this.maternoAlta}`.trim(),
          Grado: "",
          FechaNacimiento: this.formatFecha(this.nacimientoAlta) || "",
          FechaAccidente: this.dataRecibida.dateRegistro,
          HoraAccidente: this.dataRecibida.horaRegistro,
          LugarAccidente: this.dataRecibida.ubicacion,
          DescripcionAccidente: this.dataRecibida.descripcionRegistro,
          LesionAccidente: this.dataRecibida.lesion,
          ClaveInstituto: this.dataRecibida.clave,
          TelefonoInstituto: "",
          NonbreInstituto: this.dataRecibida.nombreEscuela,
          NombreHospital: this.dataRecibida.selectedHospital.NOMBRE,
          DireccionHospital: "",
          TelefonoHospital: "",
          MedicoHospital: "",
          FechaHospital: this.dataRecibida.dateConsulta,
          MunicipioHospital: "",
          NombreAcompanante:
            `${this.dataRecibida.nombre} ${this.dataRecibida.apellidoPaterno} ${this.dataRecibida.apellidoMaterno}`.trim(),
          DireccionAcompanante: "",
          TelefonoAcompanante: this.dataRecibida.telefono,
          ParentescoAcompanante: this.dataRecibida.parentesco,
        },
      };

      try {
        this.isLoading = true;
        const response = await this.$store.dispatch("metodoPost", payload); // <-- Aquí está la línea crítica para mandar el payload

        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.base64Folio = res.data;
          await this.handleDataTabs(data);
        } else {
          this.isLoading = false;
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.showError = true;
          this.mensajeError = error;
          setTimeout(() => {
            this.showError = false;
          }, 6000);
          console.log(error);
        }
      } catch (error) {
        this.isLoading = false;
        this.showError = true;
        this.mensajeError = error;
        setTimeout(() => {
          this.showError = false;
        }, 6000);
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    async handleDataTabs(data) {
      this.dataRecibida = data;
      console.log("data recibidaaa",this.dataRecibida);
      this.$set(data, "selectedPerson", this.selected);

      const payload = {
        metodo: "ALTAREGISTROISEP",
        data: {
          pNombre: this.nombreAlta,
          pApellidoPaterno: this.paternoAlta,
          pApellidoMaterno: this.maternoAlta,
          pFechaNacimiento: this.formatFecha(this.nacimientoAlta),
          pSexo: this.sexoAlta,
          pEstadoCivil: this.civilAlta,
          pAnioReporte: new Date().getFullYear(),
          pFechaOcurrido: new Date().toLocaleDateString(),
          pFechaPrimerGto: this.formatFecha(data.primerGasto),
          pFechaPrimerRecl: this.formatFecha(data.primerReclamacion),
          pNumeroPoliza: "60000893",
          pIdInciso: 1040, // FIJO POR LO MIENTRAS
          pCveIcd: data.ICD.CVEL_ICD,
          pCveCPT: data.CTP.CVEL_CPT,
          pIdUsuarioReg: "INNOVA01", // FIJO por lo mientras
          pIdPrestadorServicio: this.dataRecibida.selectedHospital.ID_PREST_SERV,
          pSitSiniestro: this.dataRecibida.autorizado === "Si" ? 1 : 0,
        },
      };

      try {
        this.isLoading = true;
        const response = await this.$store.dispatch("metodoPost", payload);

        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.showSuccess = true;
          this.mensajeSuccess = "Alta nueva generada exitosamente.";
          this.pIdFolio = res.pIdFolio;
          await this.PendienteFolioIsep();
         /* setTimeout(() => {
            this.showSuccess = false;
          }, 6000);*/
        } else {
          this.isLoading = false;
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.showError = true;
          this.mensajeError = error;
          setTimeout(() => {
            this.showError = false;
          }, 6000);
          console.log(error);
        }
      } catch (error) {
        this.isLoading = false;
        this.showError = true;
        this.mensajeError = error;
        setTimeout(() => {
          this.showError = false;
        }, 6000);
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async PendienteFolioIsep() {
      const payload = {
        IdAgente: "10909",
        NumPoliza: "60000893",
        TipoPersona: "1",
        Nombre: this.nombreAlta,
        ApellidoMaterno: this.maternoAlta,
        ApellidoPaterno: this.paternoAlta,
        FolioPendiente: this.pIdFolio,
        Requisitos: [
          {
            idRequisito: 518,
            base64: this.base64Folio,
            nombre: "AvisoAccidenteEnfermedad",
            contentType: "application/pdf",
            extension: ".pdf",
          },
        ],
      };

      try {
        this.isLoading = true;
        const response = await this.$store.dispatch("metodoPost", {
          metodo: "PENDIENTEFOLIOISEP",
          data: payload,
        });

        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.folioISEP = res.folio;
          await this.guardaDatosProceso(this.dataRecibida, this.folioISEP, "");
        } else {
          this.isLoading = false;
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.showError = true;
          this.mensajeError = error;
          setTimeout(() => {
            this.showError = false;
          }, 6000);
          console.log(error);
        }
      } catch (error) {
        this.isLoading = false;
        this.showError = true;
        this.mensajeError = error;
        setTimeout(() => {
          this.showError = false;
        }, 6000);
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    async guardaDatosProceso(data, folio, reporte) {
      const date = new Date();
      const options = { day: "2-digit", month: "2-digit", year: "numeric" };
      const formattedDate = date.toLocaleDateString("es-ES", options);
      const payload = {
        metodo: "GUARDADATOSPROCESOISEP",
        data: {
          pAutorizado: data.autorizado
            ? data.autorizado == "Si"
              ? true
              : false
            : true,
          pFechaCaptura: data.dateRegistro ? data.dateRegistro : formattedDate, //fecha actual solo cuando es registro nuevo
          pFechaOcurrido: data.dateRegistro ? data.dateRegistro : formattedDate,
          pHoraOcurrido: data.horaRegistro || "12:00:00",
          pNombre: this.nombreAlta,
          pApellidoPaterno: this.paternoAlta,
          pApellidoMaterno: this.maternoAlta,
          pSexo: this.sexoAlta,
          pNumeroPoliza: "60000893",
          pFechaNacimiento: this.nacimientoAlta,
          /*pHospital: data.selectedHospital.NombreComercial
            ? data.selectedHospital.NombreComercial
            : "",*/
          pHospital: data.selectedHospital.ID_PREST_SERV
            ? data.selectedHospital.ID_PREST_SERV
            : "",
          pNombreHospital: data.selectedHospital.NOMBRE
            ? data.selectedHospital.NOMBRE
            : "",
          pEstadoHospital: "",
          pTipoLesion: data.lesion ? data.lesion : "",
          pParteCuerpo: data.cuerpo ? data.cuerpo : "",
          pTipoAccidente: data.accidente ? data.accidente : "",
          pDescripcionAccidente: data.descripcionRegistro
            ? data.descripcionRegistro
            : "",
          pAcompanante: data.nombre
            ? `${data.nombre} ${data.apellidoPaterno} ${data.apellidoMaterno}`.trim()
            : "",
          pContacto: data.telefono ? data.telefono : "",
          pParentescoContancto: data.parentesco ? data.parentesco : "",
          pNivelEducativo: data.nivel ? data.nivel : "",
          pClaveInstitucion: data.clave ? data.clave : "",
          pNombreInstitucion: data.nombreEscuela ? data.nombreEscuela : "",
          pMunicipio: data.municipio ? data.municipio : "",
          pCosto: "",
          pNumeroReporteSis: reporte, //Se manda cuando ya existe el asegurado
          pNumeroFolioSis: this.pIdFolio, //Se manda cuando el asegurado es nuevo
          pEstatus: "Pendiente", //Alta es para los que ya existen asegurado y Pendiente es para el asegurado nuevo
          pEstadoCivil: this.civilAlta,
          pNumeroFolioInnova: this.folioISEP,
          pUsuarioAlta: this.userId,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.mensajeSuccess = `El proceso se completó correctamente. El folio asignado es: ${this.folioISEP}`;
          this.reloadPage = true;
          /*setTimeout(() => {
            window.location.reload();
          }, 8500);*/
        } else {
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.showError = true;
          this.mensajeError = error;
         /* setTimeout(() => {
            this.showError = false;
          }, 10000);*/
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
      this.isLoading = false;
    },
    formatFecha(fecha) {
      const date = new Date(fecha);
      const dia = String(date.getUTCDate()).padStart(2, "0");
      const mes = String(date.getUTCMonth() + 1).padStart(2, "0"); // Los meses en JavaScript van de 0 a 11
      const anio = date.getUTCFullYear();

      return `${dia}/${mes}/${anio}`;
    },
    getClassCTP: ({ id }) => ({
      "md-primary": id != 0,
    }),
    getClassICD: ({ id }) => ({
      "md-primary": id != 0,
    }),
    onSelectAltaICD(item) {
      this.selectedAltaICD = item;
      this.showICD = item.CVEL_ICD;
      if (item != {}) {
        setTimeout(() => {
          this.showDialogAltaICD = false;
        }, 300);
      }
    },
    onSelectAltaCTP(item) {
      this.selectedAltaCTP = item;
      this.showCTP = item.CVEL_CPT;
      if (item != {}) {
        setTimeout(() => {
          this.showDialogAltaCTP = false;
        }, 300);
      }
    },
    async CTP() {
      const payload = {
        metodo: "CATALOGOCTPISEP",
        data: {
          pCvel_CPT: this.ctpClave || null,
          pDesc_CPT: this.ctpDesc || null,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoCTP = res;
          if (res.length <= 0) {
            this.showAlert = true;
            this.mensajeAlert = "No se encontro información para CTP.";
            setTimeout(() => {
              this.showAlert = false;
            }, 5000);
          }
        } else {
          this.showError = true;
          this.mensajeError = "Hubo un error al consultar CTP";
          setTimeout(() => {
            this.showError = false;
          }, 5000);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async ICD() {
      const payload = {
        metodo: "CATALOGOICDISEP",
        data: {
          pCvel_ICD: this.icdClave || null,
          pDESC_ICD: this.icdClave != "" ? this.icdDesc : null,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoICD = res;
          if (res.length <= 0) {
            this.showAlert = true;
            this.mensajeAlert = "No se encontro información para ICD.";
            setTimeout(() => {
              this.showAlert = false;
            }, 5000);
          }
        } else {
          this.showError = true;
          this.mensajeError = "Hubo un error al consultar ICD.";
          setTimeout(() => {
            this.showError = false;
          }, 5000);
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async sexo() {
      const payload = {
        metodo: "CATALOGOSEXOISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoSexo = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async edoCivil() {
      const payload = {
        metodo: "CATALOGOEDOCIVILISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoEdoCivil = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async lesion() {
      const payload = {
        metodo: "CATALOGOLESIONISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoLesion = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async espacio() {
      const payload = {
        metodo: "CATALOGOESPACIOISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoEspacio = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async cuerpo() {
      const payload = {
        metodo: "CATALOGOCUERPOISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoCuerpo = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async accidente() {
      const payload = {
        metodo: "CATALOGOACCIDENTEISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoAccidente = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async ubicacion() {
      const payload = {
        metodo: "CATALOGOUBICACIONISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoUbicacion = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async escuelas() {
      const payload = {
        metodo: "CATALOGOESCUELASISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoEscuelas = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async hospitales() {
      const payload = {
        metodo: "CATALOGOHOSPITALESISEP",
        data: {
          PID_PREST_SERV: null,
          PCVE_PREST_ISEP: null
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoHospitales = res;
          console.log("respuesta", this.catalogoHospitales)
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    console.log("user",this.userId);
    setTimeout(async () => {
      await this.hospitales();
      await this.escuelas();
      await this.sexo();
      await this.edoCivil();
      await this.CTP();
      await this.ICD();
      await this.lesion();
      await this.espacio();
      await this.cuerpo();
      await this.accidente();
      await this.ubicacion();
    }, 2000);
  },
};
</script>
  
  <style>
.md-field.md-has-value .md-required,
.md-field.md-is-focused .md-required {
  transform: translateY(-0.5em); /* Posición ajustada */
  font-size: 12px; /* Tamaño más pequeño para el label al estar activo */
}

.md-field .md-required {
  position: absolute; /* Coloca el label en una posición absoluta */
  top: -0.1em; /* Ajusta la posición hacia arriba */
  left: 0;
  font-size: 12px; /* Tamaño inicial más grande */
  transition: all 0.2s ease-in-out; /* Animación suave */
  pointer-events: none; /* Evita que el label interrumpa el clic en el input */
}
</style>